import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostTagsUnlinkRequest = {
	sonarObjectTagId: number;
	sonarObjectId: number;
};

export const postTagUnlink = createPostEndpoint<PostTagsUnlinkRequest>('/api/v3/core/tags/unlink');
